import { api } from ".";
import { PropsWithChildren, useEffect, useState } from "react";

interface GetFlagsResponse {
    data: GetFlagsResponseData;
    error: any;
}
interface GetFlagsResponseData {
    xeroAccess: boolean;
}

const XeroFeatureFlagCheck = ({ children }: PropsWithChildren<{}>) => {
    const [xeroAccess, setXeroAccess] = useState<number>(0); // 0 - dispaly loading, 1 - show children, 2 - hide

    useEffect(() => {
        GetXeroFlags();
    }, [])

    const GetXeroFlags = async () => {
        try {
            const response: GetFlagsResponse = await api.get("api/Admin/GetFlags", {
                headers: {
                    "Authorization": localStorage.getItem("token")!
                }
            }).json();

            if (response.error == null) {
                setXeroAccess(response.data.xeroAccess ? 1 : 2);
            }
            else {
                setXeroAccess(2);
            }
        }
        catch (_err) {
            setXeroAccess(2);
        }
    }

    return (
        <>
            {xeroAccess == 0 ? <p>loading</p> : null}
            {xeroAccess == 1 ? children : null}
            {xeroAccess == 2 ? <p>Xero-related features temporary disabled. Developers are making changes</p> : null}
        </>
    )
}

export default XeroFeatureFlagCheck;